import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { orderPage, productPage } from "../../../API";
import Pagination from "../../../components/Pagination";
import { Modal } from "antd";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const [totalPages, setTotalPages] = React.useState(0)
  const [pageNum, setPageNum] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(20)
  const token = useSelector((state: any) => state?.token)
  useEffect(() => {
    if (!token) {
      return
    }
    handleLoad()
  }, [token, pageNum]);

  const [orderLi, setOrderLi] = React.useState<any>()
  const handleLoad = () => {
    orderPage({
      pageNum: pageNum,
      pageSize: pageSize,
      "params": {

      }
    }).then((res) => {
      setTotalPages(res.data?.totalPages || 0);
      setOrderLi(res.data?.records);
    }).catch((err) => {
    });
  }

  const [shopList, setShopList] = React.useState<any>()
  const [isShow, setIsShow] = React.useState(false)
  const onChange = () => {
    setIsShow(!isShow)
  }

  return (
    <div className="">
      {
        orderLi && orderLi?.length === 0 ?
          <div className="flex items-center pr-[20px] rounded-lg mt-[30px] overflow-hidden"
            style={{
              border: '1px solid rgba(0, 0, 0, .1)'
            }}
          >
            <div className="w-[4px] bg-[#000] mr-[18px]"></div>
            <div className="flex-1 py-[18px]">目前還沒有訂單</div>
            <div className="text-[#fff] text-[14px] font-bold px-[18px] py-[12px] cursor-pointer bg-[#000] my-[16px] rounded-lg"
              onClick={() => navigate('/cart')}
            >查看購物車</div>
          </div>
          :
          <div>
            <div className="flex pb-[20px] mb-[0px]"
              style={{
                borderBottom: "1px solid #cfc8d8",
              }}>
              <div className="text-[#181512] text-[16px] flex-1 font-bold">商品</div>
              <div className="text-[#181512] text-[16px] w-[20%] font-bold">價格</div>
              <div className="text-[#181512] text-[16px] w-[10%] font-bold">數量</div>
              <div className="text-[#181512] text-[16px] w-[20%] font-bold">狀態</div>
            </div>
            {
              orderLi && orderLi?.map((item: any) => (
                <div className="flex pt-[20px] mb-[0px]" key={item?.id}>
                  <div className="text-[#181512] text-[16px] flex-1 pr-6 line-clamp-1">{item?.title}</div>
                  <div className="text-[#181512] text-[16px] w-[20%] ">{item?.price?.toLocaleString() || 0}</div>
                  <div className="text-[#181512] text-[16px] w-[10%] ">{item?.quantity || 0}</div>
                  <div className="text-[#181512] text-[16px] w-[20%] flex items-center">
                    {item?.status === 'SUBMITTED' ? '已付款' : item?.status === 'SHIPPED' ? '已出貨' : item?.status === 'RECEIVED' ? '已收貨' : '--'}
                    <span className="flex-1 text-right cursor-pointer text-[#2d634e]"
                      onClick={() => {
                        setShopList(item)
                        onChange()
                      }
                      }>查看</span>
                  </div>
                </div>
              ))
            }
          </div>
      }


      <div className="flex justify-center pb-[75px]">
        {
          Math.ceil(totalPages / pageSize) > 1 ?
            <Pagination
              totalPages={Math.ceil(totalPages / pageSize)}
              currentPage={pageNum}
              onPageChange={(page: number) => setPageNum(page)}
            /> :
            ''
        }
      </div>

      <Modal
        title={`${'訂單詳情'}`}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isShow}
        footer={null}
        onCancel={() => {
          onChange();
        }}
      >
        <div>
          <div className="flex items-center pb-[10px] pt-[20px]">
            <div className="text-[#595959] text-[16px] pr-4">商品：</div>
            <div className="text-[#000] text-[16px] flex-1">{shopList?.title}</div>
          </div>
          <div className="flex items-center pb-[10px]">
            <div className="text-[#595959] text-[16px] pr-4">價格：</div>
            <div className="text-[#000] text-[16px] flex-1">{shopList?.amount}</div>
          </div>
          <div className="flex items-center pb-[10px]">
            <div className="text-[#595959] text-[16px] pr-4">狀態：</div>
            <div className="text-[#2d634e] text-[16px] flex-1 font-bold">
              {shopList?.status === 'SUBMITTED' ? '已付款' : shopList?.status === 'SHIPPED' ? '已出貨' : shopList?.status === 'RECEIVED' ? '已收貨' : '--'}
            </div>
          </div>
          <div className="flex items-center pb-[10px]">
            <div className="text-[#595959] text-[16px] pr-4">購買數量：</div>
            <div className="text-[#000] text-[16px] flex-1">{shopList?.buyQuantity}</div>
          </div>
          <div className="flex items-center pb-[10px]">
            <div className="text-[#595959] text-[16px] pr-4">創建時間：</div>
            <div className="text-[#000] text-[16px] flex-1">{shopList?.createTime}</div>
          </div>
        </div>
      </Modal>

    </div >
  );
};

export default ComponentName;
